import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const VersionsService = {
    list: async () => axios.post(API_URL + "/versions/list").then(({data}) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + "/versions/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (model) => axios.post(API_URL + "/versions", model).then(({data}) => data).catch((err) => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/versions/" + id, model).then(({data}) => data).catch((err) => { throw err }),
};

export default VersionsService;